<div class="edit-report-backdrop" (click)="close()">
  <div class="modal-dialog modal-dialog-scrollable edit-report-dialog" role="dialog" aria-modal="true"
    aria-labelledby="editReportTitle" (click)="$event.stopPropagation()">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="editReportTitle">{{ 'planner.projectDashboard.editReport.title' | translate }}</h5>
        <button type="button" class="btn-close" [attr.aria-label]="'basic.close' | translate" (click)="close()"></button>
      </div>

      <div class="modal-body">
        <dl class="report-info">
          <dt>{{ 'planner.projectDashboard.editReport.phase' | translate }}</dt>
          <dd>{{ phaseName || '-' }}</dd>
          @if (!canChangeType) {
            <dt>{{ 'planner.projectDashboard.editReport.reportType' | translate }}</dt>
            <dd>{{ reportTypeLabel }}</dd>
          }
          <dt>{{ 'planner.projectDashboard.editReport.reporter' | translate }}</dt>
          <dd>{{ report.firstname }} {{ report.lastname }}</dd>
          <dt>{{ 'planner.projectDashboard.editReport.created' | translate }}</dt>
          <dd>{{ formatDateTime(report.created) }}</dd>
          @if (report.modified) {
            <dt>{{ 'planner.projectDashboard.editReport.modified' | translate }}</dt>
            <dd>
              {{ formatDateTime(report.modified) }}
              @if (report.modified_by_name) {
                ({{ report.modified_by_name }})
              }
            </dd>
          }
        </dl>

        @if (canChangeType) {
          <div class="mb-3">
            <label for="editReportType" class="form-label">{{ 'planner.projectDashboard.editReport.reportType' | translate }}</label>
            <select id="editReportType" class="form-select" [(ngModel)]="reportType">
              @for (type of editableTypes; track type.id) {
                <option [ngValue]="type.id">{{ type.label | translate }}</option>
              }
            </select>
            @if (typeChanged) {
              <div class="form-text text-warning-emphasis">
                {{ 'planner.projectDashboard.editReport.typeChangeInfo' | translate }}
              </div>
            }
          </div>
        }

        <div class="mb-3">
          <label for="editReportAttendTime" class="form-label">{{ 'planner.projectDashboard.editReport.attendTime' | translate }}</label>
          <input id="editReportAttendTime" type="datetime-local" class="form-control" [(ngModel)]="attendTime">
        </div>

        <div class="mb-3">
          <label for="editReportNotes" class="form-label">{{ 'planner.projectDashboard.editReport.notes' | translate }}</label>
          <textarea id="editReportNotes" class="form-control" rows="4" [(ngModel)]="notes"></textarea>
        </div>

        @if (isRemarkReport) {
          <div class="mb-3">
            <label for="editReportName" class="form-label">{{ 'basic.name' | translate }}</label>
            <input id="editReportName" type="text" class="form-control" [(ngModel)]="name">
          </div>
        }

        @if (showIdentifier) {
          <div class="mb-3">
            <label for="editReportIdentifier" class="form-label">{{ 'planner.projectDashboard.editReport.identifier' | translate }}</label>
            <input id="editReportIdentifier" type="text" class="form-control" [(ngModel)]="identifier">
          </div>
        }

        @if (showInterruptCode) {
          <div class="mb-3">
            <label for="editReportInterruptCode" class="form-label">{{ 'planner.projectDashboard.editReport.interruptCode' | translate }}</label>
            <input id="editReportInterruptCode" type="text" class="form-control" [(ngModel)]="interruptCode">
          </div>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger me-auto" [disabled]="saving" (click)="remove()">
          {{ 'planner.projectDashboard.editReport.remove' | translate }}
        </button>
        <button type="button" class="btn btn-secondary" [disabled]="saving" (click)="close()">
          {{ 'basic.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
          {{ 'basic.save' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>
